import { render } from "./PopupBox.vue?vue&type=template&id=7bf7d4cb&scoped=true&ts=true"
import script from "./PopupBox.vue?vue&type=script&lang=ts"
export * from "./PopupBox.vue?vue&type=script&lang=ts"

import "./PopupBox.vue?vue&type=style&index=0&id=7bf7d4cb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf7d4cb"]])

export default __exports__